import EmbedLookup from './EmbedLookup';

export default EmbedLookup;
